<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <TableListing />
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import TableListing from "@/views/pages/productLabelNew/labelTableNew.vue";
export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.productLabel')]),
    },
    components: { Layout, PageHeader, TableListing },
    data() {
        return {
            title: i18n.t("label.listingX", [i18n.t('module.productLabel')]),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.productLabel"),
                    active: true,
                },
            ],
        };
    }
}
</script>